import styles from "./PosAccListingCard.module.scss";
import { useNavigate } from "react-router-dom";
import { PosAccListingProps } from "../../../../../types/pos";

function PosAccListingCard({
  PosAccDetails,
}: {
  PosAccDetails: PosAccListingProps;
}) {
  const { posId, businessName, businessEmail, createdAt, updatedAt } =
    PosAccDetails;
  const navigate = useNavigate();
  return (
    <>
      <div
        className={styles.card}
        onClick={() => {
          navigate(`/admin/pos/${posId}/types`);
        }}
      >
        <div className={`${styles.product} ${styles.w_40}`}>
          <div className={styles.productName}>{businessName}</div>
        </div>
        <div className={`${styles.activeProduct} ${styles.w_30}`}>
          <div className={`${styles.emailID} ${styles.textStyle}`}>
            {businessEmail}
          </div>
        </div>
        <div className={`${styles.quantity} ${styles.w_15}`}>
          <div className={`${styles.brandName} ${styles.textStyle}`}>
            {createdAt}
          </div>
        </div>
        <div className={`${styles.brandName} ${styles.w_15}`}>
          <div className={`${styles.brandName} ${styles.textStyle}`}>
            {updatedAt}
          </div>
        </div>
        <div className={`${styles.country} ${styles.w_15}`}></div>
      </div>
    </>
  );
}

export default PosAccListingCard;
